<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <Form-item label="处理状态">
        <EnumSelect
          type="TopicErrorState"
          selector="select"
          v-model="searchCondition.status"
          style="width:200px"
        ></EnumSelect>
      </Form-item>

              <Form-item label="题库分类">
                <Cascader
                  :data="catagoris"
                  v-model="classify_ids"
                  change-on-select
                  style="width:200px;"
                ></Cascader>
              </Form-item>
              <Form-item label="所属题库">
                <Input
                  style="width:200px"
                  placeholder="请输入题库名称关键字"
                  v-model="searchCondition.bank"
                  clearable
                  @keydown.native.enter="search(1)"
                />
              </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>

    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/error/question"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="multi"
        keyField="id"
        method="get"
        class="elastic-table rich-text"
      >
        <template slot-scope="{ row }" slot="action">
          <Button
            type="text"
            size="small"
            :to="{name:'QuestionTopicErrorEdit',query:{id:row.id}}"
          >处理-</Button>
          <Button type="text" size="small" @click="deleteTopic(row)">删除</Button>
        </template>
        <template slot="footer-left">
          <Button
            class="btn-margin-right"
            type="text"
            :disabled="selectList.length == 0"
            @click="batchDelete"
          >删除</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
import { TopicErrorState, QuestionType } from "../../utils/enums.js";

export default {
  name: "QuestionTopicError",
  data() {
    return {
      catagoris: [],
      classify_ids: [],
      searchCondition: {
        status: "",
        classify_id: "",
        bank: "",
      },
      columns: [
        {
          title: "反馈用户",
          key: "mobile",
          minWidth: 120
        },
        {
          title: "题目类型",
          key: "ques_type_name",
          minWidth: 120
        },
        {
          title: "题干",
          type: "html",
          key: "ques_stem",
          minWidth: 200
        },
        {
          title: "所属分类",
          key: "classify_name",
          minWidth: 200
        },
        {
          title: "所属题库",
          key: "bank_name",
          minWidth: 200
        },
        {
          title: "报错描述",
          key: "error_msg",
          type: "html",
          minWidth: 200
        },
        {
          title: "处理状态",
          key: "status_name",
          minWidth: 100
        },
        {
          title: "处理人",
          key: "operator",
          minWidth: 120
        },
        {
          title: "更新时间",
          key: "updated_at_time",
          minWidth: 120
        },
        {
          title: "操作",
          slot: "action",
          width: 120,
          align: "center",
          fixed: "right"
        }
      ],
      selectList: []
    };
  },
  async created() {
    let catagoris = await this.$http.get("/api/course/classify");
    catagoris.forEach(c => {
      c.value = c.id;
      c.label = c.name;
      c.children = c.children || [];
      c.children.forEach(child => {
        child.value = child.id;
        child.label = child.name;
      });
    });
    this.catagoris = catagoris;
  },
  methods: {
    search(flag) {
      if (flag == 0) {
        this.searchCondition.status = "";
          this.searchCondition.classify = "";
          this.searchCondition.bank = "";
          this.classify_ids = [];
      }
      if (this.classify_ids.length > 0) {
        this.searchCondition.classify_id = this.classify_ids[
          this.classify_ids.length - 1
        ];
      } else {
        this.searchCondition.classify_id = "";
      }
      this.$refs.grid.searchRefresh();
    },
    rowsFormatter(rows) {
      rows.forEach(row => {
        if (row.updated_at != 0) {
          row.updated_at_time = new Date(
            parseInt(row.updated_at) * 1000
          ).format("yyyy-MM-dd hh:mm:ss");
        }
        row.ques_type_name = QuestionType.getValue(row.ques_type);
        row.status_name = TopicErrorState.getValue(row.status);
        row.bank_name = row.question.bank.name || '';
        row.classify_name = row.question.classify.title || '';
      });
    },
    onSelectionChange(list) {
      this.selectList = list;
    },
    async deleteTopic(row) {
      if (row.status == 1) {
        this.$promiseAlert("当前题目报错未处理，无法删除", { type: "warning" });
        return;
      }
      await this.$promiseConfirm("确定要删除该题目报错吗？");
      await this.$http.delete("/api/error/question/" + row.id);
      this.$Message.deleteSuccess();
      this.$refs.grid.refresh();
    },
    async batchDelete() {
      let ids = [];
      this.selectList.forEach(t => {
        ids.push(t.id);
      });
      if (this.selectList.filter(t => t.status == 1).length > 0) {
        this.$promiseAlert("已选题目报错中有信息未处理，无法删除");
        return;
      }
      await this.$promiseConfirm("确定要批量删除已选题目报错吗？");
      await this.$http.delete("/api/error/question/" + ids.join(","));
      this.$Message.deleteSuccess();
      this.$refs.grid.refresh();
      this.selectList = [];
    }
  }
};
</script>
<style scoped lang="scss">
.elastic-table {
  /deep/ .ivu-table-wrapper {
    position: relative !important;
  }
}
</style>
